// ============================================================
// cf-exports.js — Long-running Excel export trigger + download
// ============================================================
// Public API:
//   CF.exports.trigger(exportType, parameters)
//       POST /api/v1/exports — returns Promise<exportJobId>.
//       Shows an info toast; the user is free to navigate away.
//   CF.exports.download(exportJobId, fileName)
//       GET /api/v1/exports/{id}/download with JWT, returns Promise<void>.
//       Streams response into a Blob and triggers a synthetic anchor click.
//
// SignalR events (subscribed in cf/signalr.js):
//   export.progress  — payload { exportJobId, percent, message }
//                      Forwarded to CF.exports.onProgress(payload) if defined
//   export.completed — payload { exportJobId, fileName, fileSizeBytes, rowCount }
//                      Toast with [Download] link; CF.exports.onCompleted(p) if defined
//   export.failed    — payload { exportJobId, error }
//                      Error toast; CF.exports.onFailed(p) if defined
//
// Page scripts (e.g. Pages/Exports/index.js) attach onCompleted/onFailed to
// reload their DataTable in place.
// ============================================================

window.CF = window.CF || {};

CF.exports = (function () {
    'use strict';

    function trigger(exportType, parameters) {
        return CF.auth.api({
            method:      'POST',
            url:         '/api/v1/exports',
            data:        JSON.stringify({ exportType: exportType, parameters: parameters || {} }),
            contentType: 'application/json'
        }).then(function (res) {
            if (res && res.success) {
                CF.toast.info(
                    'Export sedang diproses. Anda dapat menavigasi ke halaman lain.',
                    'Export queued');
                return res.data && res.data.exportJobId;
            }
            CF.toast.error((res && res.message) || 'Failed to queue export.');
            return null;
        });
    }

    function download(exportJobId, fileName) {
        var base = (typeof API_BASE_URL !== 'undefined' && API_BASE_URL) ? API_BASE_URL : '';
        var url  = base + '/api/v1/exports/' + encodeURIComponent(exportJobId) + '/download';
        var token = CF.auth.getAccessToken();

        return fetch(url, {
            method:  'GET',
            headers: token ? { 'Authorization': 'Bearer ' + token } : {}
        }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.blob();
        }).then(function (blob) {
            var objectUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = objectUrl;
            a.download = fileName || 'export.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
        }).catch(function () {
            CF.toast.error('Failed to download export file.');
        });
    }

    return {
        trigger:  trigger,
        download: download
    };
})();
